import { Component, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Video } from 'src/app/models/video.model';
import { UsersService } from 'src/app/services/users.service';
import { VideosService } from 'src/app/services/videos.service';

@Component({
  selector: 'channel-videos',
  templateUrl: './channel-videos.component.html',
  styleUrls: ['./channel-videos.component.scss']
})
export class ChannelVideosComponent {

  videos: Video[] = []

  dataLoaded: boolean

  channelId: string = ''

  channelTitle: string = ''

  page: number = 1

  loading: boolean

  finishedLoading: boolean
  
  userId=0


  constructor(private route: ActivatedRoute, private videosService: VideosService,private usersService:UsersService) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.channelId = params['channelId']
        this.channelTitle = params['channelTitle']

      }, err => console.log('error', err))

    this.usersService.currentUser.subscribe(u=>this.userId=u.userId)
    
    if (this.channelId)
      this.loadVideos()
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if (window.innerHeight + window.scrollY + 800 >= document.body.offsetHeight) {
      if (!this.loading && !this.finishedLoading)
        this.loadVideos()
    }
  }

  initVideos() {
    this.page = 1
    this.videos = []
    this.loadVideos()
  }

  loadVideos() {
    // this.dataLoaded = false
    this.loading = true
    this.videosService.getVideoByChannelId(this.channelId, this.page)
      .subscribe(d => {
        this.dataLoaded = true
        if (d.length == 0)
          this.finishedLoading = true
        this.videos.push(...d)
        this.loading = false
        this.page++
        console.log('channel videos', this.videos)
      }, err => console.log('error', err))
  }

}